<template>
    <div class="info-detail-container">
        <div class="news-menu">
            <div class="menu-box">
                <div class="menu-item" v-for="(item, index) in category_list" :key="index" @click="choose_category(item.id)"
                     :class="item.id === selected_category_id ? 'active' : ''">{{ item.title }}</div>
            </div>
            <Button v-show="false" class="back-btn" @click="window.close()" icon="ios-arrow-back">返回</Button>
        </div>
        <div class="news-page-body">
            <div class="left-menu">
                <div class="menu-title">{{sel_category.title}}</div>
                <div class="menu-sub-title"></div>
                <ul>
                    <li v-for="(item, index) in sub_category_list" :key="index" @click="choose_sub_category(item.id)"
                        :class="item.id === selected_sub_category_id ? 'active' : ''">{{ item.title }}</li>
                </ul>
            </div>
            <div class="right-content">
                <div class="content-box">
                    <div class="content-title">
                        {{detail.title}}
                    </div>
                    <div class="content-datetime">
                        发布时间：{{detail.create_time}} | 浏览：{{detail.total_views}}
                    </div>
                    <div class="content" v-html="detail.content"></div>
                </div>
                <div class="prev-info" v-show="false">上一篇：</div>
                <div class="next-info" v-show="false">下一篇：</div>
            </div>
            <SideMenu :mainClass="sideMenuClass"></SideMenu>
        </div>
        <div class="detail-bottom">
            <div class="bottom-box">
                <div class="box-title">
                    <div class="title">相关推荐</div>
                    <Button type="text" v-show="false">查看更多></Button>
                </div>
                <div class="item-list-box">
                    <div class="item-box" v-for="(v,k) in recommend_list" :key="`rec`+k" @click="onDetailClick(v)">
                        <img :src="v.cover|default_img" class="cover-img" />
                        <div class="title">{{v.title}}</div>
                        <div class="date-time">{{v.create_time}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SideMenu from '@/components/SideMenu/SideMenu'
import { InfoCategory, InfoDetail, InfoRecommendList } from '@/api/social'
import { addUserContribution } from "@/api";

import {mapState} from 'vuex';

export default {
    name: 'InfoDetail',
    components:{
        SideMenu
    },
    data() {
        return {
            uuid: '',
            detail: {},
            selected_category_id: 0,
            selected_sub_category_id: 0,
            category_list: [],
            banner_list:[],
            recommend_list: [],
            isBackToTopVisible: false,
            timeInterval:null,
            readTime:0
        }
    },
    computed: {
        sub_category_list() {
            let cate = this.category_list.find(v=>v.id===this.selected_category_id)
            return cate ? cate.children : []
        },
        sel_category(){
            return this.$_.cloneDeep(this.category_list.find(item => item.id === this.selected_category_id)) || {};
        },
        sideMenuClass(){
            return `position: fixed;
                    bottom: 35px;
                    right: 60px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;`
        },
        ...mapState(['taskSetting','userInfo']),
        is_login() {
            return this.$store.state.is_login;
        },
    },
    beforeRouteEnter(to, from, next) {
			next((vm) => {
			// 通过 `vm` 访问组件实例
			vm.$emit("changeFooter", 'dark');
			});
		},
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.uuid = this.$route.query.uuid;
        if(this.$route.query.code) {
            if(this.$route.query.code != this.userInfo.code) {
                addUserContribution({
                    uuid: this.uuid,
                    code:this.$route.query.code,
                    action_type:'infoShare'
                })
            }
        }
        this.getDetail()
        this.getCategoryList()
        this.getRecommendList()
        this.timeInterval = setInterval(() => {
            this.readTime++
        }, 1000);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        clearInterval(this.timeInterval)
    },

    watch: {
        readTime(value) {
            if(value >= this.taskSetting.infoRead.needTime && this.is_login) {
                console.log(this.userInfo)
                addUserContribution({
                    uuid: this.uuid,
                    user_id:this.userInfo.id,
                    action_type:'infoRead'
                })
                clearInterval(this.timeInterval)
                this.readTime = 0
            }
        }
    },
    methods: {
        choose_category(id) {
            this.$router.push({name: 'Info', params: {pid: id, cid: 0}})
        },
        choose_sub_category(id) {
            this.$router.push({name: 'Info', params: {pid: this.detail.parent_category_id, cid: id}})
        },
        async getDetail() {
            return InfoDetail({uuid: this.uuid}).then(response => {
                this.detail = response.data
                this.selected_category_id = this.detail.parent_category_id
                this.selected_sub_category_id = this.detail.child_category_id
                document.title = '衣创社区资讯' + this.detail.title;
            }).catch((res)=>{
                this.$layer.msg(res.msg)
            })
        },
        async getCategoryList() {
            return InfoCategory().then(response => {
                this.category_list = response.data
            })
        },
        async getRecommendList() {
            InfoRecommendList({page: 1, limit: 5}).then(response => {
                this.recommend_list = response.data
            })
        },
        onDetailClick(item){
            window.open(`${location.protocol}//${location.host}/info/detail?uuid=${item.uuid}`)
            // this.$router.push({name:'InfoDetail',query:{uuid:item.uuid}});
        },
        handleScroll() {
            this.isBackToTopVisible = window.pageYOffset > 100; // 滚动超过 300px 显示
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },

    }
}
</script>
<style lang="scss" scoped>
@import './InfoDetail.scss'
</style>
